import { store } from "../store/index";
import {
  filterVivero,
  removeVivero,
  modifyVivero,
  getViveroByUuid,
  createVivero,
  getAll,
} from "../store/actions/ViveroActions";

/**
 * Create Vivero
 */
export const addVivero = async (values) => {
  const objSend = { ...values };
  const result = await store.dispatch(createVivero(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Vivero
 */
export const getVivero = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getViveroByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Vivero
 */
export const updateVivero = async (values, uuid) => {
  const objSend = { ...values };
  const result = await store.dispatch(modifyVivero(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Vivero
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterVivero(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Vivero
 */
export const deleteVivero = async (uuid) => {
  const result = await store.dispatch(removeVivero([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Get all viveros
 */
export const getAllViveros = async (filters = {}) => {
  const result = await store.dispatch(getAll(filters));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
